// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.book-description p{font-family:Raleway;font-size:16px;font-style:normal;font-weight:400;line-height:24px}`, "",{"version":3,"sources":["webpack://./overrides/app/components/book-service-card/bookServicesCard.scss"],"names":[],"mappings":"AAAA,oBACE,mBAAA,CACA,cAAA,CACA,iBAAA,CACA,eAAA,CACA,gBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
